export default "__VITE_ASSET__BnbLgDq6__"